// removed by extract-text-webpack-plugin
module.exports = {"container":"no-settings__container___1Dydx","squirrel":"no-settings__squirrel___328w0"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/no-settings.scss
// module id = 1362
// module chunks = 0